import type { FC } from "react";

import { Txt } from "@ui/components/Txt/Txt";

import type { IOrderAttributeOutput } from "@jti/magento";

import styles from "./OrderAttributesInfo.module.scss";

export interface OrderAttributeInfoProps {
  orderAttributesInfos: IOrderAttributeOutput[];
}

export const OrderAttributesInfo: FC<OrderAttributeInfoProps> = ({ orderAttributesInfos }) => {
  if (orderAttributesInfos.length === 0) {
    return null;
  }

  return (
    <div className={styles.orderAttributes}>
      {orderAttributesInfos.map((attribute) => (
        <Txt key={attribute.attribute_code} variant={"txt-1"} className={styles.orderAttributesText}>
          {attribute.value}
        </Txt>
      ))}
    </div>
  );
};
